import script from "./WarningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WarningModal.vue?vue&type=script&setup=true&lang=js"

import "./WarningModal.vue?vue&type=style&index=0&id=104c3b6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104c3b6e"]])

export default __exports__